import React from 'react';
import { Icon } from './Icon';

interface CheckIconProps {
  size?: number | string;
  className?: string;
  color?: string;
}

export const CheckIcon: React.FC<CheckIconProps> = ({ size = 16, className, color = '#10b981' }) => (
  <Icon size={size} className={className} color={color} title="Success">
    <polyline points="20 6 9 17 4 12" />
  </Icon>
);

export default CheckIcon;
